<template>
  <div class="steps">
    <div class="step_box">
      <ul class="step_item clearfix">
        <li :class="{_ing: step===1}" style="text-align: left"><a href="javascript:void(0)" :class="{_end: step>=1}">1 报名须知</a></li>
        <li :class="{_ing: step===2}" style="text-align: center"><a href="javascript:void(0)" :class="{_end: step>=2}">2 开始报名</a></li>
        <li :class="{_ing: step===3}" style="text-align: center"><a href="javascript:void(0)" :class="{_end: step>=3}">3 填写信息</a></li>
        <li :class="{_ing: step===4}" style="text-align: right"><a href="javascript:void(0)" :class="{_end: step>=4}">4 预报名完成</a></li>
      </ul>
      <div class="step_box_bg"></div>
      <div class="step_box_bg step_box_bg_hover" :style="'width: '+barWidth+'%'"></div>
    </div>
  </div>
</template>

<script>
  import IndexCommon from '../mixins/index_common';
  export default {
    props: {
      step: {
        type: Number,
        default: 1
      },
    },
    mixins: [IndexCommon],
    components: {
    },
    data() {
      return {
        barWidth: 0
      };
    },
    created() {
      // console.log("-> step", this.step);
      let step = this.step;
      if(step === 1){
        this.barWidth = 23;
      } else if(step === 2){
        this.barWidth = 30;
      } else if(step === 3){
        this.barWidth = 65;
      } else if(step === 4){
        this.barWidth = 100;
      }
      // console.log("-> barWidth", this.barWidth);
    },
    methods: {}
  };
</script>

<style lang="stylus" scoped>
  .steps {
    background #f9f9f9
    padding-top 20px
    min-height 100px
    .step_box {
      width 960px
      margin 0 auto
      height 50px
      position relative
      overflow hidden
      .step_item {
        background none
        position relative
        z-index 100
        li {
          width 25%
          float left
          background none
          a {
            display inline-block
            height 46px
            overflow hidden
            line-height 45px
            border 2px solid #ccc
            width 160px
            text-align center
            background #fff
            border-radius 28px
            color #ccc
            font-size 18px
            &._end {
              color #fff
              background #35b9bf
              border-color #35b9bf
            }
            &:hover {
              text-decoration none
            }
          }
          &._ing {
            a {
              color #35b9bf
              background #fff
              border-color #35b9bf
            }
          }
        }
      }
      .step_box_bg {
        width 100%
        height 12px
        background #ccc
        border-radius 12px
        position absolute
        top 50%
        left 0
        margin-top -6px
        z-index 1
      }
      .step_box_bg_hover {
        z-index 2
        background #35b9bf
      }
    }
  }
</style>
